import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import ThemeCustomization from './mui-theme';
import { Provider } from "react-redux";
import ToastifyProvider from './ui/toastify/ToastifyProvider';
import { QueryClient, QueryClientProvider } from "react-query";
import { store } from './redux-toolkit/store/store';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 0
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  {/* <React.StrictMode> */}
  <Provider store={store}>
     <QueryClientProvider client={queryClient}>
      <ToastifyProvider>
    <ThemeCustomization>
       <Router>
      <App />
    </Router>
    </ThemeCustomization>
    </ToastifyProvider>
    </QueryClientProvider>
    </Provider>
  {/* </React.StrictMode> */}
    </>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
